/**
 * Normalizes pre-race fuel fields and migrates legacy `preRaceGel` boolean.
 */

export function getPreRaceFuelState(formData = {}) {
  let enabled = formData.preRaceFuelEnabled;
  let description = (formData.preRaceFuelDescription ?? '').trim();
  let gelEquivalents = parseFloat(formData.preRaceGelEquivalents);

  if (enabled === undefined && formData.preRaceGel !== undefined) {
    enabled = !!formData.preRaceGel;
  }

  if (!enabled) {
    return {
      enabled: false,
      description: '',
      gelEquivalents: 0
    };
  }

  if (Number.isNaN(gelEquivalents) || gelEquivalents < 0) {
    gelEquivalents = 1;
  }

  if (!description) {
    if (formData.preRaceGel) {
      description = 'Pre-race gel';
    } else {
      description = 'Pre-race fuel';
    }
  }

  return {
    enabled: true,
    description,
    gelEquivalents
  };
}

/** Footnote for total-gel summaries (CSV, print, results). */
export function formatPreRaceGelEquivsNote(preRace) {
  if (!preRace?.enabled) return '';
  if (!preRace.gelEquivalents || preRace.gelEquivalents <= 0) {
    return ' (pre-race fuel on checklist only — not counted toward gel total)';
  }
  if (preRace.gelEquivalents === 1) return ' (includes 1 pre-race gel equivalent)';
  const s = preRace.gelEquivalents % 1 === 0 ? String(preRace.gelEquivalents) : String(preRace.gelEquivalents);
  return ` (includes ${s} pre-race gel equivalents)`;
}
